"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Hur lång tid tar en badrumsrenovering?",
  answer: "En standardrenovering tar vanligtvis mellan 3 till 5 veckor beroende på omfattning och materialval. Vi upprättar alltid en tydlig tidsplan innan vi påbörjar arbetet så att du vet exakt vad som händer varje vecka."
}, {
  question: "Behöver jag ansöka om bygglov?",
  answer: "Oftast krävs inget bygglov för att renovera ett befintligt badrum. Om du däremot planerar att flytta avloppsstammar eller ändra bärande konstruktioner kan det behövas en bygganmälan. Vi hjälper dig att reda ut vad som gäller för just ditt projekt."
}, {
  question: "Kan jag använda ROT-avdraget?",
  answer: "Ja, som privatperson kan du nyttja ROT-avdraget för arbetskostnaden vid en badrumsrenovering. Vi sköter all administration direkt med Skatteverket och drar av beloppet på din faktura."
}, {
  question: "Ingår el och VVS i era tjänster?",
  answer: "Absolut. Vi erbjuder en totalentreprenad där certifierade elektriker och VVS-montörer ingår. Du får en kontaktperson och en samlad faktura för hela projektet."
}, {
  question: "Får jag ett våtrumsintyg efteråt?",
  answer: "Ja, vi är auktoriserade och efter avslutat arbete utfärdar vi ett kvalitetsdokument/våtrumsintyg. Detta är ett viktigt bevis på att renoveringen är utförd enligt gällande branschregler, vilket krävs av försäkringsbolag."
}, {
  question: "Hjälper ni till med design och materialval?",
  answer: "Vi erbjuder personlig rådgivning där vi går igenom materialval, färgsättning och planlösning. Vårt mål är att skapa ett badrum som känns både exklusivt och funktionellt utifrån dina önskemål."
}];
export default function Bathroomrenovationfaq() {
  return <section data-section-id="256918" id="bathroomrenovationfaq" className="bg-background py-16 md:py-24 text-foreground">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <h2 className="font-default text-3xl font-bold text-foreground md:text-4xl tracking-tight">
            Vanliga frågor om badrumsrenovering i Karlstad
          </h2>
        </div>

        <div className="rounded-lg border border-border bg-secondary p-4 shadow-md md:p-8">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border">
                <AccordionTrigger className="text-left font-default text-lg font-semibold text-foreground hover:text-primary hover:no-underline transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}